import React from "react";
import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-soft">
      <div className="container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto text-center space-y-8 animate-fade-in">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full mb-4">
            <span className="text-sm font-medium text-primary">Transforme conflitos em crescimento</span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold leading-tight">
            Fortaleça seu relacionamento com
            <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent"> diálogo e respeito</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-muted-foreground max-w-2xl mx-auto">
            O Casal Resolve é uma plataforma que ajuda casais a melhorarem sua comunicação, 
            resolverem conflitos e fortalecerem seu relacionamento através de ferramentas práticas e eficazes.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
            <Button variant="hero" size="xl" onClick={() => navigate("/login")}>
              Comece Gratuitamente
            </Button>
            <Button variant="outline" size="xl" onClick={() => navigate("/login")}>
              Saiba Mais
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;